const TextPackage = {
    name: 'text',
    configure: function () {
        
    }
}

export {TextPackage}
